export default "__VITE_ASSET__DwXdhdng__";